module.exports = __webpack_public_path__ + "static/images/shield-check-nofill.36b444073a4e32be6f2e42a3b421a093.svg";